/**
 * Polyfill
 */
// array.find
import 'core-js/fn/array/find'
import 'core-js/fn/string/trim'
import 'core-js/fn/object/assign'

/**
 * Vue import
 */
import { sync } from 'vuex-router-sync'

import Vue from './setup'
import router from './routers'

import store from './vuex/store'

import App from './App.vue'

import VueSticky from 'vue-sticky-js'

Vue.use(VueSticky.install)

import loading from 'vue-nice-loading'

import VueClipboard from 'vue-clipboard2'

Vue.use(loading)

Vue.use(VueClipboard)

require('minireset.css/minireset.min.css')
require('./styles/index.scss')

/**
 * Sync vuex store and vue-router
 */
sync(store, router)

/**
 * Start app
 */
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App></App>',
  components: {
    App,
  },
})



// WEBPACK FOOTER //
// ./client/main.js